import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import English from "./texts/EN.json";
import Ukrainian from "./texts/UA.json";
import Polish from "./texts/PL.json";
import Japanese from "./texts/JA.json";
import Uzbek from "./texts/UZ.json";
import Spanish from "./texts/ES.json";
import France from "./texts/FR.json";

const resources = {
  EN: {
    translation: English,
  },
  PL: {
    translation: Polish,
  },
  ES: {
    translation: Spanish,
  },
  UA: {
    translation: Ukrainian,
  },
  FR: {
    translation: France,
  },
  UZ: {
    translation: Uzbek,
  },
  JA: {
    translation: Japanese,
  },
};

if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: "EN",
      supportedLngs: ["EN", "PL", "ES", "UA", "FR", "UZ", "JA"],
    });
}

export default i18n;
